import { createAction } from '@reduxjs/toolkit';
export const ADD_CONTACT = 'ADD_CONTACT';
export const addContactAction = createAction(ADD_CONTACT, (contactData) => ({
    payload: contactData
}));